import { Service } from '@tino-frontend/adapters'
import type { ServiceConfig } from '@tino-frontend/adapters'
import type { LastOrderResponse, GetMerchantsResponseData } from '@types'

export class MerchantService {
  constructor(private readonly supplierBff: Service) {}

  async getMerchants(
    params?: Record<string, unknown>,
    options?: ServiceConfig<unknown>
  ): Promise<GetMerchantsResponseData> {
    return this.supplierBff.get('/v1/merchants', {
      ...options,
      ...(params && { params }),
    })
  }

  async getLastMerchantOrderDetails(
    supplierId: string,
    merchantDocumentNumber: string,
    userId: string
  ): Promise<LastOrderResponse> {
    return this.supplierBff.get(
      `/v1/suppliers/${supplierId}/latest-order?creator_user_id=${userId}&merchant_document_number=${merchantDocumentNumber}`
    )
  }
}
